require('./login.less');

interface UserForm {
    username: string;
    password: string;
    rememberMe?: boolean;
    token?: string;
}


class LoginController {
    headline: string;
    loginForm: UserForm;
    form: ng.IFormController;

    constructor(private $location, private userService, private hasAccessTo, private $filter) {
        this.headline = "Logg inn";
        this.loginForm = {password:'',username:''};
    }
    login() {
        this.userService.login(this.loginForm.username,this.loginForm.password).then(
            (user) => {
                const hasOrderAccess = this.hasAccessTo.orders();
                const hasPrognosisAccess = this.hasAccessTo.prognosis();
                const hasExpeditionAccess = this.hasAccessTo.expedition();
                if(hasOrderAccess){
                    this.$location.url('/orders?pageSize=100&pageNo=0&sort=vip|desc,orderNo|asc');
                }
                else if(hasPrognosisAccess){
                    this.$location.url('/prognosis');
                }
                else if(hasExpeditionAccess){
                    const date = this.$filter('date')(new Date(), 'yyyy-MM-dd');
                    this.$location.url('/booking');
                }
                else{
                    this.$location.url('/');
                }
            }
        );
    }
}

class LoginOptions implements ng.IComponentOptions {
    controller = 'rkcLoginController';
    controllerAs = "c";
    template: any = require('./login.html');
}

rkcApp.controller("rkcLoginController", ['$location','userService','hasAccessTo','$filter',function($location,userService, hasAccessTo, $filter){
    return new LoginController($location,userService, hasAccessTo, $filter);
}])
    .component("rkcLogin", new LoginOptions()
    );



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/login/login.ts
 **/